import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import globeOutline from '@iconify/icons-eva/globe-outline';
import hardDriveFilled from '@iconify/icons-eva/hard-drive-fill';
import paperPlaneOutline from '@iconify/icons-eva/paper-plane-outline';
import safetyCertificate from '@iconify/icons-ant-design/safety-certificate';
import shuffleFill from '@iconify/icons-eva/shuffle-fill';
import questionFill from '@iconify/icons-eva/question-mark-circle-fill';
import tvFill from '@iconify/icons-eva/tv-fill';
import emailFilled from '@iconify/icons-eva/email-fill';
// material
import { alpha, styled, useTheme } from '@mui/material/styles';
import { Card, Typography } from '@mui/material';
//
import { useNavigate } from 'react-router-dom';
// utils
import { fShortenNumber } from '../../../utils/formatNumber';

ItemLayanan.propTypes = {
  data: PropTypes.object.isRequired
};

export default function ItemLayanan({ data }) {
  const navigate = useNavigate();
  function getLabel(label) {
    if (label.toLowerCase() === 'subdomain') return 'Subdomain/Hosting';
    if (label.toLowerCase() === 'tte') return 'TTE';
    if (label.toLowerCase() === 'splp') return 'SPLP';
    if (label.toLowerCase() === 'vpn') return 'VPN';
    return label || '-';
  }
  const TOTAL = data?.attributes?.total || 0;
  const LABEL = getLabel(data?.attributes?.label);
  const theme = useTheme();

  function getBackgroundColor(id) {
    if (id === 'subdomain') return theme.palette.warning.lighter;
    if (id === 'hosting') return theme.palette.success.lighter;
    if (id === 'rekomendasi') return theme.palette.info.lighter;
    if (id === 'tte') return theme.palette.warning.light;
    if (id === 'aduan') return theme.palette.success.light;
    if (id === 'splp') return theme.palette.info.light;
    if (id === 'cloud') return theme.palette.secondary.lighter;
    if (id === 'backup') return theme.palette.success.lighter;
    if (id === 'vpn') return theme.palette.info.lighter;
    return theme.palette.primary.lighter;
  }

  function getColor(id) {
    if (id === 'subdomain') return theme.palette.warning.darker;
    if (id === 'hosting') return theme.palette.success.darker;
    if (id === 'rekomendasi') return theme.palette.info.darker;
    return theme.palette.primary.darker;
  }

  function getIcon(id) {
    if (id === 'subdomain') return globeOutline;
    if (id === 'hosting') return hardDriveFilled;
    if (id === 'rekomendasi') return paperPlaneOutline;
    if (id === 'tte') return safetyCertificate;
    if (id === 'email') return emailFilled;
    if (id === 'splp') return shuffleFill;
    if (id === 'aduan') return questionFill;
    if (id === 'videotron') return tvFill;
    return globeOutline;
  }

  const RootStyle = styled(Card)(({ theme }) => ({
    boxShadow: 'none',
    textAlign: 'center',
    padding: theme.spacing(5, 0),
    color: getColor(data.id),
    backgroundColor: getBackgroundColor(data.id),
    cursor: 'pointer'
  }));

  const IconWrapperStyle = styled('div')(({ theme }) => ({
    margin: 'auto',
    display: 'flex',
    borderRadius: '50%',
    alignItems: 'center',
    width: theme.spacing(8),
    height: theme.spacing(8),
    justifyContent: 'center',
    marginBottom: theme.spacing(3),
    color: theme.palette.primary.dark,
    backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.primary.dark, 0)} 0%, ${alpha(
      theme.palette.primary.dark,
      0.24
    )} 100%)`
  }));

  const handleNavigate = (id) => {
    // navigate(`/dashboard/services?page=${1}&size=${10}&search=${id}`);
    navigate(`/dashboard/services?page=${1}&size=${10}&type=${id}`);
  };
  return (
    <RootStyle onClick={() => handleNavigate(data.id)}>
      <IconWrapperStyle>
        <Icon icon={getIcon(data.id)} width={24} height={24} />
      </IconWrapperStyle>
      {/* <Typography variant="h3">{fShortenNumber(TOTAL)}</Typography> */}
      <Typography variant="h3">{TOTAL}</Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        {LABEL}
      </Typography>
    </RootStyle>
  );
}
